module.exports = __webpack_public_path__ + "static/img/head.668da927.png";